import { Box, CircularProgress } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { ChangeEvent, Fragment, PureComponent } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { SearchInputTextField } from './SearchInput.styled';

interface IProps {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  spinner?: boolean;
  value: string;
  disabled?: boolean;
}

class SearchInput extends PureComponent<IProps & WithTranslation> {
  render(): JSX.Element {
    const { value, onChange, spinner, t, disabled } = this.props;
    const error = value !== '' && !spinner && value?.length < 3;

    return (
      <Fragment>
        <SearchInputTextField
          color="primary"
          variant="outlined"
          fullWidth
          placeholder={t('common.search')}
          size="small"
          InputProps={{
            startAdornment: (
              <Box display="flex" alignItems="center" justifyContent="center" width="60px">
                {spinner ? <CircularProgress size={16} /> : <SearchIcon color="disabled" />}
              </Box>
            ),
          }}
          onChange={onChange}
          value={value}
          error={error}
          helperText={error && t('errormessage.general.searcherror')}
          disabled={disabled}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(SearchInput);
